<template>
  <div class="bbp-list-requests-earnings">
    <div class="bbp-list-requests-earnings__text">Potential earnings:</div>
    <div class="bbp-list-requests-earnings__text bbp-list-requests-earnings__text_value">
      {{ value }}
    </div>
    <div
      v-html="AED_ICON()"
      class="bbp-list-requests-earnings__icon"
    />
  </div>
</template>

<script>
import {AED_ICON} from '@/constants/icons'
import convertNumber from '@/mixin/convertNumber'

export default {
  name: 'ListOfRequestsEarnings',
  props: {
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  mixins: [convertNumber],
  data: () => ({
    AED_ICON
  }),
  computed: {
    value () {
      return this.convertNumber(this.totalAmount)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-list-requests-earnings {
    width: max-content;
    display: flex;
    align-items: center;
    min-width: 140px;
    background: $color-white;
    border-radius: 4px;
    padding: 9px 12px 9px 12px;

    &__text {
      color: $color-denim;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;

      &_value {
        font-weight: 600;
        margin: 0 8px 0 15px;
      }
    }

    &__icon {
      margin: 0 8px 0 -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Requests/ListOfRequests/ListOfRequestsEarnings.vue